import { h, Component } from "preact";

import Autocomplete from "./Autocomplete";
import Tooltip from "./Tooltip";

import styles from "./style.css";

class Form extends Component {
    constructor() {
        super();
        this.state = {
            eligibility_restricted: true,
            origin: {
                lat: null,
                lng: null,
                name: null
            }
        };
    }

    onSubmit(e) {
        e.preventDefault();
        // TODO handle form validation before submitting
        this.props.handleFormSubmit(this.state);
    }

    handleAutocompleteInput(coords) {
        this.setState({origin: coords});
    }

    onToggle(e) {
        const { name } = e.target;
        let checked = !this.state[name];
        this.setState({ [name]: checked});
    }

    render() {
        return (
            <form onSubmit={(e) => this.onSubmit(e)}>
                <fieldset class={styles.formLegend}>
                    <legend>
                        Are you an older adult or have a disability?
                        <Tooltip message="Age requirements vary by provider, see program details" />
                    </legend>
                    <input
                        type="radio"
                        id="yes_eligible"
                        name="eligibility_restricted"
                        onClick={(e) => this.onToggle(e)}
                        checked={this.state.eligibility_restricted}
                    />
                    <label for="yes_eligible">Yes</label>
                    <input
                        type="radio"
                        id="no_eligible"
                        name="eligibility_restricted"
                        onClick={(e) => this.onToggle(e)}
                        checked={!this.state.eligibility_restricted}
                    />
                    <label for="no_eligible">No</label>
                </fieldset>
                <div class={styles.autoCompleteSection}>
                    <div>
                        <p class={styles.mobileLabel}>Enter your specific starting location (25 Ridgewood Rd, Springfield Plaza, etc.)</p>
                        <Autocomplete
                            programBounds={this.props.programBounds}
                            handleInput={(coords) => this.handleAutocompleteInput(coords)}
                            />
                    </div>
                    <div>
                        <input
                            type="submit"
                            value="Get programs"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default Form;